<template>
  <div>
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item
        label="文章标题"
        prop="title"
        required
        :label-width="formLabelWidth"
      >
        <el-input v-model="form.title" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item
        label="归属年份-期号"
        prop="year"
        required
        :label-width="formLabelWidth"
      >
        <el-date-picker
          v-model="form.year"
          type="year"
          placeholder="选择年"
          value-format="yyyy"
        >
        </el-date-picker>
        <el-input
          v-model="form.issueNumber"
          type="number"
          autocomplete="off"
          placeholder="请输入期号"
          style="width: 20%;"
          min="1"
        ></el-input>
        <!-- <el-select
          v-model="form.issueNumber"
          placeholder="请选择活动期号"
          allow-create
          filterable
        >
          <el-option
            v-for="item in issueList"
            :key="item"
            :label="item"
            :value="item"
          ></el-option>
        </el-select> -->
      </el-form-item>
      <el-form-item
        label="发表时间"
        prop="publishTime"
        required
        :label-width="formLabelWidth"
      >
        <el-date-picker
          v-model="form.publishTime"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item
        label="附件上传（pdf）"
        prop="filedId"
        required
        :label-width="formLabelWidth"
      >
        <el-upload
          class="upload-demo"
          :action="action"
          :file-list="fileList"
          :on-success="(response, file) => handleSuccess(response, file)"
          :limit="1"
          accept=".pdf"
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传pdf文件</div>
        </el-upload>
      </el-form-item>
      <el-form-item label="文章正文" :label-width="formLabelWidth">
        <div style="border: 1px solid #ccc">
          <Toolbar
            style="border-bottom: 1px solid #ccc"
            :editor="editor"
            :defaultConfig="toolbarConfig"
            :mode="mode"
          />
          <Editor
            style="height: 500px; overflow-y: hidden"
            v-model="form.content"
            :defaultConfig="editorConfig"
            :mode="mode"
            @onCreated="onCreated"
          />
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose(true)">取 消</el-button>
      <el-button type="primary" v-if="!id" @click="handleAdd(0)"
        >保 存</el-button
      >
      <el-button type="primary" v-if="!id" @click="handleAdd(1)"
        >发 布</el-button
      >
      <el-button type="primary" v-if="id" @click="handleUpdate(0)"
        >保 存</el-button
      >
      <el-button type="primary" v-if="id" @click="handleUpdate(1)"
        >发 布</el-button
      >
    </div>
  </div>
</template>

<script>
import baseURL from "@/api/baseUrl.js";
import {
  addMedicalFrontiers,
  updateMedicalFrontiers,
  getMedicalFrontiersDetail,
  uploadFile,
  deleteSysFileInfo,
} from "@/api/api";
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";

export default {
  props: ["id"],
  components: { Editor, Toolbar },
  data() {
    return {
      form: {
        title: "",
        year: "",
        issueNumber: "",
        publishTime: "",
        filedId: "",
        content: "",
      },
      issueList: [12, 11, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1],
      formLabelWidth: "130px",
      fileList: [],
      action: baseURL,
      headers: { Authorization: "Bearer " + sessionStorage.getItem("token") },
      rules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        year: [{ required: true, message: "请选择年份", trigger: "change" }],
        issueNumber: [
          { required: true, message: "请选择期号", trigger: "change" },
        ],
        publishTime: [
          {
            required: true,
            message: "请选择发布时间",
            trigger: "change",
          },
        ],
        filedId: [
          {
            required: true,
            message: "请上传文件",
            trigger: "change",
          },
        ],
      },
      filedIds: [],
      editor: null,
      toolbarConfig: {},
      editorConfig: { placeholder: "请输入正文..." },
      mode: "default", // or 'simple'
    };
  },
  mounted() {
    if (this.id) {
      this.handleGetDetail();
    }
  },
  methods: {
    async handleAdd(status) {
      let flag = false;
      this.$refs["form"].validate((valid) => {
        if (valid) {
          flag = true;
        }
      });
      if (flag) {
        const res = await addMedicalFrontiers({ ...this.form, status });
        if (res.data.code === 200) {
          this.$message.success("添加成功");
          this.$parent.$parent.handleClose();
        }
      }
    },
    async handleUpdate(status) {
      let flag = false;
      console.log(1);
      this.$refs["form"].validate((valid) => {
        console.log(3);
        if (valid) {
          flag = true;
        }
      });
      console.log(2);

      if (flag) {
        const res = await updateMedicalFrontiers({
          ...this.form,
          id: this.id,
          status,
        });
        if (res.data.code === 200) {
          this.$message.success("修改成功");
          this.$parent.$parent.handleClose();
        }
      }
    },
    async handleGetDetail() {
      const res = await getMedicalFrontiersDetail({
        ...this.form,
        id: this.id,
      });
      if (res.data.code === 200) {
        this.form = { ...res.data.data };
        this.fileList.push({ name: this.form.filedId + ".pdf", url: "" });
      }
    },
    handleSuccess(response, file) {
      if (response) {
        const formData = new FormData();
        formData.append("file", file.raw);
        console.log(formData.get("file"));
        uploadFile(formData).then((res) => {
          if (res.data) {
            this.form.filedId = res.data.data;
            this.filedIds.push(res.data.data);
            this.$forceUpdate();
            this.$message.success("文件上传成功");
          }
        });
      }
    },
    handleClose(flag) {
      // 仅在新增并取消发布或保存的时候删除没用到的文件
      if (!this.id && flag && this.filedIds.length > 0) {
        deleteSysFileInfo({ fileIds: this.filedIds });
      }
      this.$parent.$parent.handleClose();
    },
    onCreated(editor) {
      this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
    },
    beforeDestroy() {
      const editor = this.editor;
      if (editor == null) return;
      editor.destroy(); // 组件销毁时，及时销毁编辑器
    },
  },
};
</script>

<style></style>
